import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './CourtList.css';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Swal from "sweetalert2";

const UnavailableDate = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const courtId = queryParams.get('courtId');
  const [unavailableDates, setUnavailableDates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const token = localStorage.getItem('auth-token');
  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}`;
  };
  const courtData = queryParams.get('courtId') || null;

  useEffect(() => {
    const fetchUnavailableDates = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_UNAVAILABLE_DATES}/?courtId=${courtData}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        const data = await response.json();

        if (data.success) {
          const transformedData = data.data.courtUnavailableDates.map(item => ({

            id: item.id,
            courtName: data.data.academyCourtEntity.name,
            startDate: formatDateTime(item.startDate),
            endDate: formatDateTime(item.endDate),
            reason: 'Unknown',
          }));

          setUnavailableDates(transformedData);
        } else {
          throw new Error(data.success_message || 'Failed to fetch data');
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUnavailableDates();
  }, [courtId]);

  const navigate = useNavigate();

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredUnavailableDates = unavailableDates.filter((date) =>
    Object.values(date)
      .join(' ')
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const handleEdit = (event, id, startDate, endDate) => {
    const url = `/addunavailableDate?courtId=${courtId}&unavailableDateId=${id}&startDate=${encodeURIComponent(
      startDate
    )}&endDate=${encodeURIComponent(endDate)}`;

    if (event.metaKey || event.ctrlKey) {
      window.open(url, "_blank");
    } else {
      navigate(url);
    }
  };


  const handleDelete = async (id) => {
    const url = `${process.env.REACT_APP_API_DELETE_UNAVAILABLE_DATE}/${courtId}/${id}`;

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to undo this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to delete date");
        }
        setUnavailableDates(unavailableDates.filter((item) => item.id !== id));
        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "Unavailable date has been deleted.",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
      } catch (error) {
      }
    }
  };

  return (
    <div className="enrollment-container">
      <div className="breadcrumb">
        <Link to="/courtlist" className="breadcrumb-link">Court List</Link> &gt; Unavailable Date
      </div>
      <div className="search-bar">
        <div className="input-container">
          <input
            type="text"
            id="searchInput"
            placeholder=""
            className={`search-input ${searchTerm ? 'has-value' : ''}`}
            value={searchTerm}
            onChange={handleSearchChange}
          />
          <label htmlFor="searchInput" className="floating-label">
            🔍 Search
          </label>
        </div>
        <button
          className="create-button-new"
          onClick={(event) => {
            const url = `/addunavailableDate?courtId=${courtId}`;
            if (event.metaKey || event.ctrlKey) {
              window.open(url, "_blank");
            } else {
              navigate(url);
            }
          }}
        >
          <span className="create-button__icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="23"
              height="23"
              className="create-button__svg"
            >
              <path
                d="M12 5v14M5 12h14"
                stroke="white"
                strokeWidth="2.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <span className="create-button__label">
            Add Unavailable Date
          </span>
        </button>

      </div>
      {loading && (
        <div className="premium-loader">
          <div className="progress-track">
            <div className="progress-bar"></div>
          </div>
          <div className="status-text">
            <span>L</span>
            <span>O</span>
            <span>A</span>
            <span>D</span>
            <span>I</span>
            <span>N</span>
            <span>G</span>
          </div>
        </div>
      )}
      {error && <div className="error-message">{error}</div>}
      {!loading && !error && filteredUnavailableDates.length === 0 && (
        <div className="error-message">No data available</div>
      )}

      <div className="tt-table-container">
        <table className="tt-table">
          <thead>
            <tr className="courtlist-header-row">
              <th className="courtlist-column courtlist-column-action">Court Name</th>
              <th className="courtlist-column courtlist-column-action">Start Date</th>
              <th className="courtlist-column courtlist-column-action">End Date</th>
              <th className="courtlist-column courtlist-column-action">Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredUnavailableDates.map((item) => (
              <tr key={item.id} className="courtlist-row">
                <td className="courtlist-cell courtlist-cell-name">{item.courtName}</td>
                <td className="courtlist-cell courtlist-cell-date">{item.startDate}</td>
                <td className="courtlist-cell courtlist-cell-date">{item.endDate}</td>
                <td className="courtlist-cell courtlist-cell-action action-buttons">
                  <button
                    className="edit-btn tooltip-btn"
                    onClick={(e) => handleEdit(e, item.id, item.startDate, item.endDate)}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="white" strokeWidth="2">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M16.862 3.487a2.12 2.12 0 0 1 3.001 3.001L7.5 18.85l-4 1 1-4L16.862 3.487z" />
                    </svg>
                    <span className="tooltip-text">Edit</span>
                  </button>

                  <button
                    className="delete-btn tooltip-btn"
                    onClick={() => handleDelete(item.id)}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="white" strokeWidth="2">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M6 7h12M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M10 11v6M14 11v6M5 7h14l-1 12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 7z" />
                    </svg>
                    <span className="tooltip-text">Delete</span>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UnavailableDate;
